import { createSelector } from 'reselect';

import { getUuid } from 'store/auth/selectors';

import { selectExtendedUsers } from './';

const selectManagedUsersIds = ({ managedUsers }) => managedUsers;

export const selectManagedUsers = createSelector(
  [selectManagedUsersIds, selectExtendedUsers, getUuid],
  (managedUsersIds, users, uuid) =>
    [uuid, ...managedUsersIds].reduce((acc, id) => {
      if (users[id]) {
        acc.push({ name: users[id].name, id });
      }

      return acc;
    }, []),
);
